import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, allocationWarningConfig }) =>
    present(
      repository
        .updateAllocationWarningConfig(planzone, allocationWarningConfig)
        .then((savedPlanzone) => ({
          planzone: savedPlanzone,
          allocationWarningConfig,
        }))
        .catch((error) =>
          Promise.reject({ error, planzone, allocationWarningConfig }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
